<app-header />
<div class="profile bg_2">
    <div class="top_padding5 profile_content">
        <div class="p-top-40 p-x-40 profile_content_top">
            <p class="text_black_15">Welcome <span class="text_blue_16">ChemRobotics® TM</span></p>
        </div>
        <div class="p-top-40  profile_content_bottom" *ngIf="profile">
            <div class="profile_content_bottom_grid">
                <div>
                    <img width="100%" [src]="logo_url+profile.user_image" class="border-radius-20" />
                </div>
                <div class="profile_content_bottom_grid_body ">
                    <div class="profile_content_bottom_grid_body_setting">
                        <div class="profile_content_bottom_grid_body_setting_name">
                            <p class="text_black_7">{{profile.name}}</p>
                        </div>
                        <div class="profile_content_bottom_grid_body_setting_acc">
                            <div>
                                <span class="text_black_13 font-style-i">Account Create: {{profile.created_at}}</span>
                            </div>
                            <div class="p-x-20">
                                <button  class="button_blue_7 text_white_1"
                                    [routerLink]="['/edit_profile']">Settings</button>
                            </div>
                        </div>
                    </div>
                    <div class="p-top-16">
                        <button class="text_blue_17 button_light-blue_1 ">Research Scientist</button>
                    </div>
                    <div class="p-top-16">
                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.17001 8.57827C8.82171 8.81047 8.41713 8.93322 8 8.93322C7.5829 8.93322 7.17832 8.81047 6.83002 8.57827L1.09321 4.75362C1.06139 4.7324 1.03038 4.71028 1 4.68753V10.9546C1 11.6732 1.58311 12.2434 2.28879 12.2434H13.7112C14.4297 12.2434 15 11.6603 15 10.9546V4.6875C14.9695 4.7103 14.9385 4.73248 14.9066 4.75373L9.17001 8.57827Z"
                                fill="#0032A0" />
                            <path
                                d="M1.54824 4.07087L7.28504 7.89555C7.50221 8.04034 7.75109 8.11272 7.99997 8.11272C8.24888 8.11272 8.49779 8.04031 8.71496 7.89555L14.4518 4.07087C14.7951 3.84214 15 3.45933 15 3.04617C15 2.33575 14.422 1.75781 13.7116 1.75781H2.28836C1.57796 1.75784 1 2.33578 1 3.04685C1 3.45933 1.20497 3.84214 1.54824 4.07087Z"
                                fill="#0032A0" />
                        </svg>
                        <span class="p-x-10 text_black_4_res">{{profile.email}}</span>
                    </div>
                    <div class="p-top-16">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.6866 6.71552C13.7058 4.45971 11.7845 2.39174 9.40375 2.10578C9.3564 2.10016 9.30482 2.09161 9.25021 2.08257C9.13235 2.06304 9.01046 2.04297 8.88748 2.04297C8.39953 2.04297 8.26909 2.38573 8.23476 2.59015C8.20137 2.78891 8.23322 2.95581 8.32927 3.08645C8.49086 3.30617 8.77518 3.34518 9.00355 3.37643C9.07049 3.38568 9.13364 3.39427 9.18651 3.40615C11.3255 3.88411 12.0458 4.63557 12.3978 6.75641C12.4064 6.80824 12.4103 6.87209 12.4144 6.93981C12.4297 7.19333 12.4617 7.72078 13.0288 7.72078H13.0288C13.0761 7.72078 13.1268 7.71671 13.1796 7.70866C13.7077 7.62841 13.6911 7.14627 13.6832 6.91462C13.6809 6.84938 13.6788 6.78766 13.6843 6.74662C13.6858 6.73629 13.6865 6.7259 13.6866 6.71552Z"
                                fill="#0032A0" />
                            <path
                                d="M8.74919 1.27642C8.81255 1.28099 8.87252 1.28537 8.92246 1.29302C12.435 1.83319 14.0503 3.49739 14.498 7.03737C14.5056 7.09754 14.5068 7.17093 14.508 7.24865C14.5125 7.52522 14.5217 8.10057 15.1396 8.1125L15.1587 8.1127C15.3525 8.1127 15.5067 8.05426 15.6169 7.93888C15.8093 7.73769 15.7959 7.43881 15.785 7.19861C15.7824 7.13968 15.7799 7.08417 15.7805 7.03558C15.8252 3.41511 12.6913 0.132075 9.07401 0.00998758C9.05901 0.00949068 9.0447 0.0102857 9.03024 0.012323C9.02313 0.0133665 9.00996 0.0146584 8.9874 0.0146584C8.95133 0.0146584 8.90696 0.0115279 8.8599 0.00834783C8.80301 0.00447205 8.73851 0 8.67312 0C8.09707 0 7.98755 0.409441 7.97354 0.653516C7.94124 1.21759 8.48693 1.25729 8.74919 1.27642Z"
                                fill="#0032A0" />
                            <path
                                d="M14.3285 11.6132C14.2538 11.5561 14.1766 11.4971 14.1043 11.4388C13.7208 11.1302 13.3128 10.8458 12.9182 10.5706C12.8364 10.5136 12.7545 10.4565 12.6729 10.3992C12.1674 10.0442 11.713 9.87169 11.2837 9.87169C10.7055 9.87169 10.2013 10.1912 9.78523 10.8212C9.60088 11.1005 9.37723 11.2363 9.1016 11.2363C8.93862 11.2363 8.75342 11.1898 8.55124 11.098C6.91979 10.3582 5.75482 9.22389 5.08863 7.7266C4.76659 7.00292 4.87099 6.52988 5.43775 6.14488C5.75959 5.92645 6.35864 5.51979 6.31621 4.74106C6.26816 3.85673 4.31695 1.19591 3.49484 0.893701C3.14677 0.765701 2.78105 0.764509 2.4059 0.89072C1.4608 1.20843 0.782593 1.7664 0.444407 2.50419C0.117599 3.21708 0.132357 4.05415 0.48709 4.92491C1.51258 7.44247 2.95437 9.63745 4.77256 11.4488C6.55223 13.2219 8.73961 14.6743 11.2739 15.7656C11.5023 15.8638 11.7419 15.9175 11.9169 15.9566C11.9765 15.97 12.028 15.9814 12.0655 15.9917C12.0861 15.9973 12.1074 16.0003 12.1287 16.0005L12.1487 16.0006C12.1487 16.0006 12.1487 16.0006 12.1488 16.0006C13.3408 16.0006 14.772 14.9114 15.2115 13.6697C15.5966 12.5824 14.8935 12.045 14.3285 11.6132Z"
                                fill="#0032A0" />
                            <path
                                d="M9.27641 4.15278C9.07233 4.15795 8.64763 4.16848 8.49862 4.60103C8.4289 4.80316 8.43725 4.97867 8.52346 5.12267C8.64997 5.33395 8.89236 5.39869 9.11283 5.43422C9.91238 5.56252 10.323 6.00465 10.4052 6.82552C10.4433 7.20828 10.7011 7.47556 11.032 7.47556C11.0564 7.47556 11.0815 7.47412 11.1064 7.47109C11.5044 7.42374 11.6973 7.13131 11.6799 6.60202C11.6862 6.04962 11.3972 5.42249 10.9055 4.92296C10.4121 4.4219 9.81737 4.13971 9.27641 4.15278Z"
                                fill="#0032A0" />
                        </svg>
                        <span class="p-x-10 text_black_4_res">{{profile.mobile_no}}</span>
                    </div>
                    <div class="p-top-16">
                        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6 0C2.68811 0.00439329 0.0043933 2.68811 0 6C0 10.3075 5.59 15.7025 5.8275 15.93C5.92355 16.0233 6.07645 16.0233 6.1725 15.93C6.41 15.7025 12 10.3075 12 6C11.9956 2.68811 9.31189 0.00439329 6 0ZM6 8.75C4.48122 8.75 3.25 7.51877 3.25 5.99999C3.25 4.48121 4.48122 3.25 6 3.25C7.51878 3.25 8.75 4.48121 8.75 5.99999C8.74909 7.5184 7.51841 8.74908 6 8.75Z"
                                fill="#0032A0" />
                        </svg>
                        <span
                            class="p-x-10 text_black_4_res">{{profile.address}},{{profile.state}},{{profile.pincode}},{{profile.country_name}}</span>
                    </div>
                    <div class="p-top-16 profile_content_bottom_grid_body_account">
                        <div>
                            <span class="text_black_13 font-style-i">Account Create: {{profile.created_at}}</span>
                        </div>
                        <div class="p-x-20 profile_content_bottom_grid_body_account_set">
                            <button  class="button_blue_7 text_white_1"
                                [routerLink]="['/edit_profile']">Settings</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile_content_bottom_profession">
                <div class="bottom-border-1 width-100-per">
                    <div class="text_black_10 p-top-40 ">
                        <span class="bottom-border-2">Profession Details</span>
                    </div>
                </div>
                <div class=" p-top-40 profile_content_bottom_profession_detail">
                    <div>
                        <p class="text_black_16">Company Name</p>
                        <p class="text_black_13">{{profile.company_name
                            }}</p>
                    </div>
                    <div>
                        <p class="text_black_16">Occupation</p>
                        <p class="text_black_13">{{profile.occupation
                            }}</p>
                    </div>
                    <div>
                        <p class="text_black_16">Institute/Company Affiliation</p>
                        <p class="text_black_13">{{profile.institute_company
                            }}</p>
                    </div>
                    <div>
                        <p class="text_black_16">Name of Department</p>
                        <p class="text_black_13">{{profile.department_name
                            }}</p>
                    </div>
                    <div>
                        <p class="text_black_16">Education</p>
                        <p class="text_black_13">{{profile.education
                            }}</p>
                    </div>
                    <div>
                        <p class="text_black_16">Industry</p>
                        <p class="text_black_13">{{profile.
                            industry}}</p>
                    </div>
                </div>
            </div>
            <div class=" profile_content_bottom_box">
                <div class="bg_3  profile_content_bottom_box_body">
                    <div class="text_white_18 p-x-20">Latest Message: <span class="text_white_17">Your Account will
                            Expire
                            after 7 days</span></div>
                    <div class="text_white_18 p-x-20">Account Status: <span class="text_white_17"> Trial A/c</span>
                    </div>
                    <div class="text_white_18 p-x-20">Start Date: <span
                            class="text_white_17">{{profile.start_date}}</span></div>
                    <div class="text_white_18 p-x-20">End Date: <span
                            class="text_white_17">{{profile.expired_date}}</span></div>
                </div>
            </div>

        </div>
    </div>
</div>

<app-footer />